var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { FloatingArrow, FloatingNode, FloatingPortal, arrow, autoUpdate, offset, shift, useDismiss, useFloating, useFloatingNodeId, useFocus, useHover, useInteractions, useRole, } from '@floating-ui/react';
import { useRef, useState } from 'react';
import style from './Tooltip.module.scss';
export function Tooltip(_a) {
    var tooltip = _a.tooltip, children = _a.children;
    var arrowRef = useRef(null);
    var nodeId = useFloatingNodeId();
    var _b = useState(false), isOpen = _b[0], setIsOpen = _b[1];
    var _c = useFloating({
        open: isOpen,
        onOpenChange: setIsOpen,
        middleware: [
            offset(10),
            shift(),
            arrow({
                element: arrowRef,
            }),
        ],
        whileElementsMounted: autoUpdate,
    }), x = _c.x, y = _c.y, strategy = _c.strategy, refs = _c.refs, context = _c.context;
    var hover = useHover(context, { move: false });
    var focus = useFocus(context);
    var dismiss = useDismiss(context);
    var role = useRole(context, { role: 'tooltip' });
    // Merge all the interactions into prop getters
    var _d = useInteractions([hover, focus, dismiss, role]), getReferenceProps = _d.getReferenceProps, getFloatingProps = _d.getFloatingProps;
    return (_jsxs(_Fragment, { children: [_jsx("button", __assign({ type: "button", className: style.button, ref: refs.setReference }, getReferenceProps(), { children: children })), isOpen && (_jsx(FloatingNode, __assign({ id: nodeId }, { children: _jsx(FloatingPortal, { children: _jsxs("div", __assign({ className: style.tooltip, ref: refs.setFloating, style: {
                            position: strategy,
                            top: y !== null && y !== void 0 ? y : 0,
                            left: x !== null && x !== void 0 ? x : 0,
                            width: 'max-content',
                            zIndex: 1021, // 1020 = header
                        } }, getFloatingProps(), { children: [tooltip, _jsx(FloatingArrow, { ref: arrowRef, context: context, height: 6, width: 12, fill: "#E60032" })] })) }) })))] }));
}
